module.exports = __webpack_public_path__ + "img/img03.38b30f59.png";